import { render, staticRenderFns } from "./ButtonScrollTop.vue?vue&type=template&id=42e21340"
import script from "./ButtonScrollTop.vue?vue&type=script&lang=js"
export * from "./ButtonScrollTop.vue?vue&type=script&lang=js"
import style0 from "./ButtonScrollTop.vue?vue&type=style&index=0&id=42e21340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports